<template>
  <AboutMenu :menu="lang == 'zh' ? menu : enMenu" />
</template>

<script>
import AboutMenu from "@/views/components/AboutMenu";

export default {
  data() {
    return {
      lang: this.$global.lang,
      menu: [
        { name: "研发核心", url: "/product" },
        { name: "产品介绍", url: "/productIntroduce/top" },
        { name: "管理体系认证", url: "/quality" },
        { name: "产品认证", url: "/assunce" },
        { name: "应用领域", url: "/use/one" },
        { name: "手册下载", url: "/use/three" },
        { name: "检测服务", url: "/service" },
        { name: "仪器管理系统", url2: "http://sys.zfsycf.com.cn:11180/" },
      ],
      enMenu: [
        { name: "PRODUCTS", url: "/productIntroduce/top" },
        { name: "QUALITY ASSURANCE", url: "/productIntroduce/two" },
      ],
    };
  },
  components: {
    AboutMenu,
  },
};
</script>

<style lang="scss">
</style>